import Cookies from "js-cookie";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const useUserLoginValidate = () => {
	const navigate = useNavigate();

	const userCookies = Cookies.get("E_current_userId");
	const tokenCookie = Cookies.get("E_token");
	const userObjRaw = Cookies.get("E_current_user_obj");

	useEffect(() => {
		let isVerified = true;
		if (userObjRaw && userObjRaw !== "undefined" && userObjRaw !== "null") {
			try {
				const parsed = JSON.parse(userObjRaw);
				if (parsed && parsed.isVerified === false) {
					isVerified = false;
				}
			} catch (e) {}
		}

		if (
			isVerified &&
			userCookies &&
			userCookies !== "undefined" &&
			userCookies !== "null" &&
			tokenCookie &&
			tokenCookie !== "undefined" &&
			tokenCookie !== "null"
		) {
			return navigate("/Home");
		} else {
			return navigate("/");
		}
	}, []);
};

export default useUserLoginValidate;


